import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIngeregeldXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M9.6 9.21L8.86 10.5H10.35C10.63 10.5 10.85 10.72 10.85 11C10.85 11.28 10.63 11.5 10.35 11.5H8.86L9.6 12.79C9.74 13.03 9.66 13.33 9.42 13.47C9.34 13.52 9.25 13.54 9.17 13.54C9 13.54 8.83 13.45 8.74 13.29L8 12L7.26 13.29C7.17 13.45 7 13.54 6.83 13.54C6.75 13.54 6.66 13.52 6.58 13.47C6.34 13.33 6.26 13.03 6.4 12.79L7.14 11.5H5.66C5.38 11.5 5.16 11.28 5.16 11C5.16 10.72 5.38 10.5 5.66 10.5H7.14L6.4 9.21C6.26 8.97 6.34 8.67 6.58 8.53C6.82 8.39 7.12 8.47 7.26 8.71L8 10L8.74 8.71C8.88 8.47 9.18 8.39 9.42 8.53C9.66 8.67 9.74 8.97 9.6 9.21Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 0C10.21 0 12 1.79 12 4V6C13.1 6 14 6.9 14 8V14C14 15.1 13.1 16 12 16H4C2.9 16 2 15.1 2 14V8C2 6.9 2.9 6 4 6V4C4 1.79 5.79 0 8 0ZM8 1C6.35 1 5 2.35 5 4V6H11V4C11 2.35 9.65 1 8 1ZM12 15C12.55 15 13 14.55 13 14V8C13 7.45 12.55 7 12 7H4C3.45 7 3 7.45 3 8V14C3 14.55 3.45 15 4 15H12Z'
    />
  </svg>
);
export default SvgIngeregeldXs;
